import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { FormattedMessage } from 'react-intl';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import FormActions from '@afosto/app-components-react/Form/FormActions';
import TextField from '@afosto/app-components-react/TextField';
import translations from './translations';

const ConfirmationSection = ({ debitSource, setCurrentStep }) => {
  const intl = useIntl();
  return (
    <>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <Typography variant="body1" paragraph>
          <FormattedMessage {...translations.description} />
        </Typography>
        {debitSource ? (
          <>
            <TextField
              name="bank"
              value={debitSource && debitSource.ideal.bank}
              label={intl.formatMessage(translations.fields.bank)}
              inline
              disabled
              readOnly
              margin="dense"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              name="accountNumber"
              value={debitSource && `**** **** **** **** ${debitSource.ideal.iban_last4}`}
              label={intl.formatMessage(translations.fields.accountNumber)}
              inline
              disabled
              readOnly
              margin="dense"
              InputLabelProps={{ shrink: true }}
            />
          </>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" p={5}>
            <CircularProgress />
          </Box>
        )}
        <FormActions>
          <Button
            type="button"
            color="primary"
            variant="contained"
            onClick={() => setCurrentStep('accountName')}
          >
            <FormattedMessage {...translations.actions.continue} />
          </Button>
        </FormActions>
      </CardContent>
    </>
  );
};

ConfirmationSection.propTypes = {
  debitSource: PropTypes.object,
  setCurrentStep: PropTypes.func,
};

ConfirmationSection.defaultProps = {
  debitSource: null,
  setCurrentStep: undefined,
};

export default ConfirmationSection;
